// extracted by mini-css-extract-plugin
module.exports = {"accepted":"ConsentStatus_accepted__2kpoX","declined":"ConsentStatus_declined__1ost1","withdrawn":"ConsentStatus_withdrawn__2VJjr"};